import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import './styles/index.scss';
import App from './components/App';
import {HomePage} from './components/auth/HomePage';
import {store} from './store/rootReducer';
import * as serviceWorker from './serviceWorker';
import {CssBaseline, ThemeProvider} from '@mui/material';
import {createTheme} from '@mui/material/styles';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {defaultTheme} from './styles';
import WebSocketClientProvider from './websocket/WebSocketClientProvider';
import {HashRouter} from 'react-router-dom';
import {ConfigProvider} from 'antd';
import {MDSConfigProvider} from '@mds/merck-design-system';
import {initAnalytics} from './analytics';

initAnalytics();

if (import.meta.env.MODE === 'development' && import.meta.env.VITE_MSW) {
  require('./test/browserServer');
}
const muiTheme = createTheme();
const container = document.getElementById('root');
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <>
      {window.location.href.indexOf('registration') > -1 ? (
        <HomePage />
      ) : (
        <Provider store={store}>
          <WebSocketClientProvider enabled={!import.meta.env.VITE_MSW}>
            <ThemeProvider theme={defaultTheme}>
              <CssBaseline />
              <HashRouter>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <ConfigProvider
                    theme={{
                      components: {
                        Modal: {
                          // it's a temporary fix to override MUI's z-index
                          // TBD: delete after deleting MUI
                          zIndexPopupBase: muiTheme.zIndex.modal + 1,
                        },
                      },
                    }}
                  >
                    <MDSConfigProvider>
                      <App />
                    </MDSConfigProvider>
                  </ConfigProvider>
                </LocalizationProvider>
              </HashRouter>
            </ThemeProvider>
          </WebSocketClientProvider>
        </Provider>
      )}
    </>,
  );
}

serviceWorker.unregister();
